<template lang="pug">
  .submit-button-container
    button.submit-button(
      :disabled="isButtonDisabled"
      type="button"
      @click="onClick"
    )
      template(v-if="isLoading")
        .spinner.submit-button__spinner
      template(v-else) Забронировать
</template>

<script>
import {bookEvents} from '@/store/api/api'
import CheckoutModal from '@/components/CheckoutModal'
import {mapGetters} from 'vuex';

export default {
  name: 'SubmitButton',
  data() {
    return {
      isSuccess: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters('places', {isPlacesValid: 'isValid'}),
    ...mapGetters('user', {
      isUserOk: 'getIsOk'
    }),
    isButtonDisabled() {
      return !this.isUserOk || !this.isPlacesValid;
    }
  },
  methods: {
    async onClick() {
      try {
        this.isLoading = true;
        // Отправлять запрос на проведение брони
        await bookEvents(/*options*/);
        this.isSuccess = true;
      } catch (error) {
        console.error(error);
      }

      this.isLoading = false;
      this.$modal.show(
          CheckoutModal,
          {
            isSuccess: this.isSuccess
          },
          {
            adaptive: true,
            clickToClose: false,
            height: 'auto',
            scrollable: true,
          });
    },
  }
}
</script>
